// extracted by mini-css-extract-plugin
export default {"BranchInfoBarContainer":"BranchInfoBar-module__BranchInfoBarContainer--vaFVP","Box":"BranchInfoBar-module__Box--NhDLA"};